// removed by extract-text-webpack-plugin
module.exports = {"spinner":"_spinner__spinner__3jLpF","spin":"_spinner__spin__QWBLz","isFixed":"_spinner__isFixed__1zKem","isAbsolute":"_spinner__isAbsolute__Bj2Qa","isStatic":"_spinner__isStatic__2WevC"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/components/OverlaySpinner/_spinner.scss
// module id = 394
// module chunks = 4 6 7 8 9 12 17 18 22 26 37